import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Toast, Picker, List } from 'antd-mobile';
import Http from '../../config/axiosUtils';
import TeamCommon from '../../components/team/TeamCommon';

import '../../assets/scss/Group/groupHome.scss';
import Empty from "../../components/common/Empty";
import TeamData from "../../components/team/TeamData";
import queryString from "query-string";
import {getStore} from "../../config/storage";

class GroupHome extends Component {
  state = {
    teamData: {},
    referrerList: [],
    teamCount: null,
    teamStatus: ["团队业绩","团队成员"],
    currentIndex: '团队业绩',
    teamLevel: null,
    litData: [],
    type: ['100']
  }

  componentDidMount() {
    this.fetchListData();
    this.fetchData(this.state.type[0])
    const { from } = queryString.parse(this.props.location.search);
    this.setState({
      from: from,
      teamLevel: getStore('teamLevel')
    }, () => {
      this.getTeamData();
    })
  }
  fetchListData = async () => {
    const path = '/spread/web/customer/productList';
    const res = await Http.get(path);
    if (res.code === 0) {
      const data = res.data.map((o) => ({
        label: o.value,
        value: o.code,
      }));
      this.setState({
        litData: data,
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  fetchData = async (code) => {
    const path = `/spread/web/team/myTeam/${code}`;
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        teamData: res.data.teamCountData,
        teamCount: res.data.teamAccountCount
      });
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  getTeamData = async () => {
    const path = '/spread/web/team/referrer/statistic';
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        referrerList: res.data,
      })
    } else {
      Toast.fail(res.msg, 2);
    }
  }

  //点击title
  changeTeam = (item) => {
    this.setState({
      currentIndex: item
    })
  }
  onChangeType = (type) => {
    
    this.setState({
      type: type
    }, () => {
      this.fetchData(type[0]);
    })
  }

  groupClickFuc = (id) => {
    this.props.history.push(`/teamHome/${id}?teamLevel=${this.state.teamLevel}&code=${this.state.type[0]}`);
  }

  render () {
    const { currentIndex, teamData, referrerList } = this.state;
    return (
    <div>
        <Helmet><title>我的团队</title></Helmet>
        <div className='groupHome'>
          <div className='group-top'>
            <div>我的团队(人)</div>
            <div className='top-money'>{this.state.teamCount}</div>
          </div>
          <div className='group-content'>
            <div className='content-bg'>
              {/*<div className='content-top'>团队数据 <span>包含团队成员数据</span></div>*/}
              <ul className='team-title'>
                {
                  this.state.teamStatus.map((item, index) => {
                    return (
                        <li
                            key={index}
                            className={currentIndex === item ? 'team-high' : ''}
                            onClick={this.changeTeam.bind(this, item)}>
                          {item}
                          {currentIndex === item && <i></i>}
                        </li>
                    )
                  })
                }
              </ul>
              <div className='list-zwl'>
                <div>
                  {this.state.litData.length > 0 && this.state.litData.find(o => o.value === this.state.type[0])?.label}<i className='iconfont icon-arrrow'></i>
                  <div className='common-pick list-type-pick'>
                  <Picker
                    extra='请选择'
                    data={this.state.litData}
                    cols={1}
                    value={this.state.type}
                    onChange={this.onChangeType}>
                    <List.Item arrow="horizontal"> 产品 </List.Item>
                  </Picker>
                </div>
                </div>
                
              </div>
            </div>
            <div className='content-detail'>
              {currentIndex === '团队业绩' && (!teamData ? <Empty /> : <TeamCommon teamData={teamData} isGroupHome></TeamCommon>
              )}
              {currentIndex === '团队成员' && (referrerList.length < 1 ? <Empty tip='暂无数据' /> : <TeamData teamList={referrerList} teamLevel={this.state.teamLevel} code={this.state.type[0]} groupClickFuc={this.groupClickFuc}></TeamData>)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GroupHome;
